module.exports = {
	"id": "WF",
	"name": "Wallis and Futuna",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.040467,
			"26": null,
			"27": 3.578439,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.323736,
			"32": null,
			"33": 0.075153,
			"34": 0.387327,
			"35": 0.167649,
			"36": null,
			"37": null,
			"38": 0.167649,
			"39": null,
			"40": null,
			"41": 0.075153,
			"42": null,
			"43": 0.040467,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": 0.023124,
			"49": 1.647585,
			"50": 0.011562,
			"51": 0.179211,
			"52": 0.219678,
			"53": 16.435383,
			"54": 1.607118,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.011562,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.052029,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.011562,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.011562,
			"39": null,
			"40": 0.052029,
			"41": null,
			"42": null,
			"43": 0.011562,
			"44": 0.375765,
			"45": 0.75153,
			"46": 0.144525,
			"47": 0.040467,
			"48": 2.422239,
			"49": 7.064382,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.260145,
			"37": 0.092496,
			"38": null,
			"39": null,
			"40": 0.011562,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.011562,
			"8": 0.104058,
			"9": 1.231353,
			"10": 0.283269,
			"3.1": null,
			"3.2": null,
			"5.1": 0.040467,
			"6.1": 0.052029,
			"7.1": null,
			"9.1": 0.23124
		},
		"ios_saf": {
			"8": 0,
			"10": 1.23727707827,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0333431855745,
			"8.1-8.4": 0.0616001225021,
			"9.0-9.2": 0.0293872144047,
			"9.3": 0.448343399251
		},
		"android": {
			"3": 0,
			"4": 0.0336538837209,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00420673546512,
			"4.1": 0.121394366279,
			"4.2-4.3": 0.303485915698,
			"4.4": 0.695914238372,
			"4.4.3-4.4.4": 0.701923860465
		},
		"ie": {
			"6": null,
			"7": 0.011562,
			"8": null,
			"9": 0.196554,
			"10": 0.063591,
			"11": 11.093739,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0104743224087,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000290953400242
		},
		"edge": {
			"12": null,
			"13": 1.167762,
			"14": 0.040467
		},
		"ie_mob": {
			"10": 0.019965971831,
			"11": 0.081290028169
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 7.885311
		},
		"and_uc": {
			"0": 0.291111
		},
		"op_mini": {
			"0": 0.141118724191
		},
		"and_chr": {
			"0": 36.568171
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 99.489034
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/WF.json
 ** module id = 682
 ** module chunks = 0
 **/